import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function WatchIcon(props: IconProps) {
    return <Icon {...props} iconKey={"watch"}/>
}
